import React, {useState, useEffect} from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import AddCommentPopUp from '../components/AddCommentPopUp';
import { Loading } from './Loading';
import siteUtils from '../utils/siteUtils';
import RequestUtils from '../utils/requestUtils';
import "../styles/Vendor.css";

const WorklistComments = (props) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {  
    if (props.Request) {  
      setIsLoading(false);  
    }  
  }, [props.Request]);  

  const loadTable = () => {
      props.refresh(props.currentCompanyId);
    setIsLoading(true);
  }

  const buildTable = () => {
      if (props.Request.requestComments?.length > 0) {
        const commentRow = props.Request.requestComments.map((comment, index) => (
          <Col key={index} sm={3} className="commentArea borderCurve">
            <Card className="commentCard border-0">
              <Card.Body>
                <Card.Title>{`${comment.commentContact.lastName}, ${comment.commentContact.firstName}`}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                  {siteUtils.formatDate(comment.createdDt)}
                </Card.Subtitle>
                <Card.Text>{comment.comment}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ));
        return <div className="cardRow">{commentRow}</div>;
      }
      return <Col><h4>No Comments</h4></Col>;
    };

    const showPopupButton = () => {
      if (props.Request && props.Request.bankRequest) {
        return RequestUtils.checkCommentsAndAttachmentsPerms(
          props.Request.bankRequest.requestStatusId,
          props.currentUser,
          props.currentCompanyId
        );
      }
      return false;
    };

    return (
      <>
        <Container fluid>
          <Row>
            <Col md={2}>
              <h3 className="commentsHeader">Comments</h3>
            </Col>
            <Col md={1} className="offset-md-9 pl-1">
               <AddCommentPopUp currentUser={props.currentUser} currentCompanyId={props.currentCompanyId} Request={props.Request} commentTableLoad={loadTable} showButton={showPopupButton}/>
            </Col>
          </Row>
        </Container>

        <Container className="vendorArea border-left-dark shadow borderCurve worklistTable" fluid>
          {isLoading ? <Loading/> :  buildTable()}
        </Container>
      </>
    );
  };
export default WorklistComments;